import {NotificationService} from "./NotificationService";
import {environment} from '../../Environments/environment';
import {EPlatform, IVersionVm, ProxyContainer} from "../Data/Data";
import {CordovaService} from "./CordovaService";


export class VersionService {

  static $inject = [
    "$proxy",
    "$http",
    '$interval',
    "$q",
    CordovaService.serviceId,
    NotificationService.serviceId,
  ];
  static serviceId = "version";

  constructor(private $proxy: ProxyContainer,
              private $http: angular.IHttpService,
              private $interval: ng.IIntervalService,
              private $q: ng.IQService,
              private cordova: CordovaService,
              private notification: NotificationService) {

  }

  getVersionNumber(): Promise<string> {
    return this.cordova.appVersion;
  }


  async startVersionCheck() {

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').then(registration => {
        const intervalMs = environment.updateCheckInterval;
        setInterval(() => {
          registration.update()
              .then(() => {
                if (registration.waiting) {
                  // New service worker is waiting to activate
                  // Send message to service worker to skip waiting
                  registration.waiting.postMessage({type: 'SKIP_WAITING'});

                  console.log('[SW] update check successful, waiting for reload');
                  // Reload the page to activate the new service worker
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch(err => console.error('[SW] update check failed:', err));
        }, intervalMs);
      });
    }
  }
}
